import rightImg from "images/about-hero-right.png";
import videoplayback from "images/videoplayback.mp4";
import React, { FC,useState,useEffect,ComponentType } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Route, Redirect,useHistory,Link,useParams,useLocation} from 'react-router-dom';
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionAboutVideo from "./SectionAboutVideo";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import axios from 'axios'; 

export interface PageCommonProps {
  className?: string;
}
const PageCommon: FC<PageCommonProps> = ({
  className = "" 
}) => {

  const params                                      = useParams();
  // yuo can find all params from here
  const slug                                        = Object.values(params);
  let search                                                  = window.location.search;
  const history                                               = useHistory();
  let searchParams                                            = new URLSearchParams(search);
  const location                                              = useLocation();
  const [description, setDescription]                         = useState("");
  const [metaTitle, setMetaTitle]                             = useState("");
  const [bannnerUrl, setBannnerUrl]                           = useState("");
  const [isVideo, setIsVideo]                                 = useState("no");
  const [isImages, setIsImages]                               = useState("no");
  const [isdataLoaded, setIsdataLoaded]                       = useState(false);

  useEffect(() => {
      axios.get(process.env.REACT_APP_BASE_URL+'getPageCommon?slug='+slug[0])
  .then(res => {
    setDescription(res.data.page_details.content_html);
    setMetaTitle(res.data.page_details.meta_title);
    setBannnerUrl(res.data.page_details.banner_url);
    setIsVideo(res.data.page_details.is_video);
    setIsImages(res.data.page_details.is_images);
    setIsdataLoaded(true);
  })
}, [slug[0]]);

const renderskeletonLoader = () => {
  return (
    <div className="custom-loader"><div className="h-screen skeleton"></div></div>
  );
};

  return (
    <div className={`nc-PageCommon overflow-hidden relative ${className}`} data-nc-id="PageCommon">
      <Helmet title={metaTitle}></Helmet>
      {isdataLoaded  ?
      <div className="container py-16 pt-0 lg:py-18 space-y-16 lg:space-y-28">
        {isVideo=='yes'?
          <video width="100%"  loop autoPlay={true} height="100%" controls className="group  bg-neutral-800 rounded-l overflow-hidden border-4 border-white dark:border-neutral-900 sm:rounded-[50px] sm:border-[10px]" > 
          <source src={bannnerUrl} type="video/mp4"/> </video>
        :
          ""
        }
        {isImages=='yes'?
          <img className="w-full" src={bannnerUrl} alt="hero" />
        :
        ""
        }
        <div className="our-tiny p-0 pl-0">
            <div className="common-content-descriptions"  dangerouslySetInnerHTML={ {__html: description} } />
        </div>
      </div>
      :
      <div className="container py-16 pt-0 lg:py-18 space-y-16 lg:space-y-28">
        {renderskeletonLoader()}
      </div>
      }

    </div>
  );
};

export default PageCommon;
